import React from 'react';
import './HashtagCreateToInnovate.scss';

const HashtagCreateToInnovate = () => {
  return (
    <div className="hashtag-create-to-innovate">
      <span className="hashtag-create-to-innovate__hashtag">#</span>
      <span className="hashtag-create-to-innovate__C">C</span>
      <span className="hashtag-create-to-innovate__reate">reate</span>
      <span className="hashtag-create-to-innovate__T">T</span>
      <span className="hashtag-create-to-innovate__o">o</span>
      <span className="hashtag-create-to-innovate__I">I</span>
      <span className="hashtag-create-to-innovate__nnovate">nnovate</span>
    </div>
  );
};

export default HashtagCreateToInnovate;
